import React, { useState } from 'react';

const DataFormContext = React.createContext<any>(null);

export const DataFormProvider = ({ children }: { children: React.ReactNode }) => {
    const [dataFile, setDataFile] = useState<any>({});
    const [dataDetail, setDataDetail] = useState<any[]>([]);

    const value = { dataFile, setDataFile, dataDetail, setDataDetail };

    return <DataFormContext.Provider value={value}>{children}</DataFormContext.Provider>;
};

export const useDataFormContext = () => React.useContext(DataFormContext);

